module.exports = __webpack_public_path__ + "img/43a989dad814079107c7a881b5f661e4.png";